import _toConsumableArray from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState, useEffect } from 'react';
import { BUSINESS_TYPE_FOLDER, DEFAULT_MAP_SETTINGS } from './constants';
import { getGoogleStaticMapsApiKey } from '../../../utils/utilityFunction';
import { APIProvider } from '@vis.gl/react-google-maps';
import { initClusters, CloseSites } from './ClusterComposite';
export var Context = /*#__PURE__*/React.createContext();

/**
 * @typedef {Object} Location
 * @property {Array<number>} cltr - Clusters
 * @property {number} lat - Latitude
 * @property {number} lng - Longitude
 * @property {string} fId - Folder ID
 * @property {string} yId - Yext ID
 * 
 * @typedef {['General Practice'|'Ethos'|'Pet Resorts'|'Equine']} BusinessTypes
 */

/**
 * Get the proper file name by adding the IDs in the correct order at the end.
 * @param {BusinessTypes} businessTypes
 * @return {string} - URL of the JSON file that contains the locations
 */
var getNameFileByBusinessType = function getNameFileByBusinessType(businessTypes) {
  var businessIds = '';
  Object.keys(BUSINESS_TYPE_FOLDER).forEach(function (key) {
    if (businessTypes.includes(BUSINESS_TYPE_FOLDER[key].name)) {
      businessIds += "_".concat(BUSINESS_TYPE_FOLDER[key].folderId);
    }
  });
  if (!businessIds) {
    return;
  }
  return "".concat(process.env.NEXT_PUBLIC_MAP_FILES, "coordinates_locations").concat(businessIds, ".json");
};

/**
 * Fetch locations used for markers and to get the IDs to fetch the location data.
 * @param {BusinessTypes} businessTypes
 * @return {Object} JSON Data
 * (e.g. https://codesguat.z22.web.core.windows.net/map/coordinates_locations_266099_266104_266124_266127.json
)
 */
var fetchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(businessTypes) {
    var fileName, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileName = getNameFileByBusinessType(businessTypes);
            _context.prev = 1;
            _context.next = 4;
            return fetch(fileName);
          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();
          case 7:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error('Error fetching data:', _context.t0);
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));
  return function fetchData(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Fetch data used on info window and side bar.
 * @param {Location} location 
 * @returns {Object} Yext Data
 */
var fetchLocationData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(location) {
    var fileName, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            fileName = "".concat(process.env.NEXT_PUBLIC_MAP_FILES, "sites/").concat(location.yId, ".json");
            _context2.next = 4;
            return fetch(fileName);
          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();
          case 7:
            return _context2.abrupt("return", _context2.sent);
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            console.error('Error fetching locations data:', _context2.t0);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));
  return function fetchLocationData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var clustersTree = null;
var closeSites = null;
var MapStateProvider = function MapStateProvider(_ref3) {
  var children = _ref3.children,
    initialData = _ref3.initialData;
  var API_KEY = getGoogleStaticMapsApiKey();
  var businessLineLocations = initialData.businessLineLocations;
  var _useState = useState(false),
    isLoaded = _useState[0],
    setIsLoaded = _useState[1];
  var _useState2 = useState(false),
    isLoadingLocations = _useState2[0],
    setIsLoadingLocations = _useState2[1];
  var _useState3 = useState([]),
    closestLocationsFromCenter = _useState3[0],
    setClosestLocationsFromCenter = _useState3[1];
  var _useState4 = useState([]),
    allCoorLocations = _useState4[0],
    setAllCoorLocations = _useState4[1];
  var _useState5 = useState(),
    selectedLocation = _useState5[0],
    setSelectedLocation = _useState5[1];
  var _useState6 = useState(null),
    selectedLocationKey = _useState6[0],
    setSelectedLocationKey = _useState6[1];
  var init = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(allCoorLocations.length !== 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              getData(businessLineLocations);
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function init() {
      return _ref4.apply(this, arguments);
    };
  }();

  /**
   * @param {BusinessTypes} businessTypes
   */
  var getData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(businessTypes) {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setIsLoaded(false);
              setIsLoadingLocations(true);
              _context4.next = 4;
              return fetchData(businessTypes);
            case 4:
              data = _context4.sent;
              setAllCoorLocations(data === null || data === void 0 ? void 0 : data.s);
              clustersTree = initClusters(data === null || data === void 0 ? void 0 : data.c, data === null || data === void 0 ? void 0 : data.s);
              closeSites = new CloseSites(DEFAULT_MAP_SETTINGS.CENTER.lat, DEFAULT_MAP_SETTINGS.CENTER.lng);
              getFirstClosestLocations();
              setIsLoaded(true);
              setIsLoadingLocations(false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function getData(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
   * Used when filtering business types on Filters.js
   * @param {BusinessTypes} businessTypes
   */
  var handleBusinessTypeFilter = function handleBusinessTypeFilter(businessTypes) {
    setClosestLocationsFromCenter([]);
    getData(businessTypes);
  };

  /**
   * Used on side bar infinite scroll. Fetches more locations data and orders it from closest to the center.
   */
  function getMoreClosestLocations() {
    return _getMoreClosestLocations.apply(this, arguments);
  }
  /**
   * Set selected location. Used on marker click or list item click to display info window data.
   * @param {Location} location
   */
  function _getMoreClosestLocations() {
    _getMoreClosestLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var locationsToFetch, fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (clustersTree) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              setIsLoadingLocations(true);
              locationsToFetch = clustersTree.getOrderedSitesFromCenter(closeSites);
              _context6.next = 6;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 6:
              fetchedLocations = _context6.sent;
              setClosestLocationsFromCenter([].concat(_toConsumableArray(closestLocationsFromCenter), _toConsumableArray(fetchedLocations)));
              setIsLoadingLocations(false);
            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _getMoreClosestLocations.apply(this, arguments);
  }
  function handleSelectLocation(_x4) {
    return _handleSelectLocation.apply(this, arguments);
  }
  /**
   * Get Locations on marker click or side bar location click.
   * @param {Location} site
   * @return {Location[]} Array of locations
   */
  function _handleSelectLocation() {
    _handleSelectLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(location) {
      var locationData;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (location) {
                _context7.next = 4;
                break;
              }
              setSelectedLocation(null);
              _context7.next = 11;
              break;
            case 4:
              setIsLoadingLocations(true);
              _context7.next = 7;
              return fetchLocationData(location);
            case 7:
              locationData = _context7.sent;
              setSelectedLocation(locationData);
              getLocationData(location);
              setIsLoadingLocations(false);
            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _handleSelectLocation.apply(this, arguments);
  }
  function getLocationData(_x5) {
    return _getLocationData.apply(this, arguments);
  }
  /**
   * Get locations from the cluster
   * @param {string} clusterIndex - string number
   * @param {Object} recentCloseSites - CloseSites
   * @param {Object} recentCloseSites.center - {lat, lng}
   * @param {Array} recentCloseSites.listStudied
   * @returns {Location[]} Array of locations
   */
  function _getLocationData() {
    _getLocationData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(site) {
      var clusterIndex, firstCluster;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              clusterIndex = site.cltr.join('');
              closeSites = new CloseSites(site.lat, site.lng);
              firstCluster = getSitesFromCluster(clusterIndex, closeSites);
              fetchLocations(firstCluster);
              return _context8.abrupt("return", firstCluster);
            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _getLocationData.apply(this, arguments);
  }
  var getSitesFromCluster = function getSitesFromCluster(clusterIndex, recentCloseSites) {
    if (!clustersTree) {
      return;
    }
    var firstCluster = clustersTree.getOrderedSitesFromClusterIndexAndCenter(clusterIndex, recentCloseSites);
    return firstCluster;
  };

  /**
   * Get closest locations to the center on first load and on business type filter change.
   */
  function getFirstClosestLocations() {
    return _getFirstClosestLocations.apply(this, arguments);
  }
  /**
   * Get the first cluster on first load.
   */
  function _getFirstClosestLocations() {
    _getFirstClosestLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var locationsToFetch, fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (clustersTree) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _context9.prev = 2;
              setIsLoadingLocations(true);
              locationsToFetch = clustersTree.getThreeClustersOrdered(closeSites);
              _context9.next = 7;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 7:
              fetchedLocations = _context9.sent;
              setClosestLocationsFromCenter(_toConsumableArray(fetchedLocations));
              setIsLoadingLocations(false);
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](2);
              console.error('Error fetching locations data:', _context9.t0);
            case 15:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 12]]);
    }));
    return _getFirstClosestLocations.apply(this, arguments);
  }
  var getFirstCluster = function getFirstCluster(recentCloseSites) {
    if (!clustersTree) {
      return;
    }
    var firstCluster = clustersTree.getThreeClustersOrdered(recentCloseSites);
    return firstCluster;
  };

  /**
   * Get locations closest to the center that will be used in the side bar.
   * @param {Location[]} locationsToFetch
   */
  var fetchLocations = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(locationsToFetch) {
      var fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (locationsToFetch) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              setIsLoadingLocations(true);
              _context5.prev = 3;
              _context5.next = 6;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 6:
              fetchedLocations = _context5.sent;
              setClosestLocationsFromCenter(_toConsumableArray(fetchedLocations));
              _context5.next = 13;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](3);
              console.error('Error fetching locations data:', _context5.t0);
            case 13:
              setIsLoadingLocations(false);
            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 10]]);
    }));
    return function fetchLocations(_x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  /**
   * Get the cluster from the new center on first load, on map restart or on location search.
   */
  var getFirstClusterFromNewCenter = function getFirstClusterFromNewCenter(lat, lng) {
    closeSites = new CloseSites(lat, lng);
    var firstCluster = getFirstCluster(closeSites);
    fetchLocations(firstCluster);
    return firstCluster;
  };
  useEffect(function () {
    init();
  }, []);
  return __jsx(Context.Provider, {
    value: {
      isLoaded: isLoaded,
      setIsLoaded: setIsLoaded,
      getData: getData,
      allCoorLocations: allCoorLocations,
      closestLocationsFromCenter: closestLocationsFromCenter,
      getMoreClosestLocations: getMoreClosestLocations,
      isLoadingLocations: isLoadingLocations,
      getFirstClusterFromNewCenter: getFirstClusterFromNewCenter,
      selectedLocation: selectedLocation,
      handleSelectLocation: handleSelectLocation,
      selectedLocationKey: selectedLocationKey,
      setSelectedLocationKey: setSelectedLocationKey,
      handleBusinessTypeFilter: handleBusinessTypeFilter
    }
  }, __jsx(APIProvider, {
    apiKey: API_KEY
  }, children));
};
export default MapStateProvider;